export default __webpack_public_path__ + "static/media/Enlightment60s.1074c9c3.mp3";